var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var colors = [
    "primary",
    "secondary",
    "success",
    "error",
    "warning",
    "info",
    "grey",
];
function containedVariants() {
    return Object.fromEntries(colors.map(function (colorName) { return [
        "contained".concat(colorName[0].toUpperCase()).concat(colorName.slice(1)),
        function (_a) {
            var theme = _a.theme;
            var color = theme.palette[colorName];
            return {
                backgroundColor: color[200],
                color: theme.palette.getContrastText(color[200]),
                "&:hover": {
                    backgroundColor: color[300],
                    color: theme.palette.getContrastText(color[700]),
                },
                "&:focus-visible": {
                    backgroundColor: color[700],
                    color: theme.palette.getContrastText(color[700]),
                    outline: "3px solid ".concat(color[300]),
                },
                "&:active": {
                    backgroundColor: color[300],
                    color: theme.palette.getContrastText(color[300]),
                },
            };
        },
    ]; }));
}
function outlinedVariants() {
    return Object.fromEntries(colors.map(function (colorName) { return [
        "outlined".concat(colorName[0].toUpperCase()).concat(colorName.slice(1)),
        function (_a) {
            var theme = _a.theme;
            var color = theme.palette[colorName];
            return {
                background: theme.palette.white.main,
                color: theme.palette.black.main,
                borderColor: theme.palette.grey[600],
                "&:hover": {
                    backgroundColor: color[100],
                    color: theme.palette.getContrastText(color[100]),
                },
                "&:focus-visible": {
                    borderColor: color[300],
                    outline: "2px solid ".concat(color[300]),
                },
                "&:active": {
                    backgroundColor: color[200],
                    color: theme.palette.getContrastText(color[200]),
                },
            };
        },
    ]; }));
}
function textVariants() {
    return Object.fromEntries(colors.map(function (colorName) { return [
        "text".concat(colorName[0].toUpperCase()).concat(colorName.slice(1)),
        function (_a) {
            var theme = _a.theme;
            var color = theme.palette[colorName];
            return {
                "&:hover": {
                    backgroundColor: color[100],
                    color: theme.palette.getContrastText(color[100]),
                },
                "&:focus-visible": {
                    outline: "3px solid ".concat(color[300]),
                },
                "&:active": {
                    backgroundColor: color[200],
                    color: theme.palette.getContrastText(color[500]),
                },
            };
        },
    ]; }));
}
export var MuiButton = {
    defaultProps: {
        variant: "contained",
        disableRipple: true,
    },
    styleOverrides: __assign(__assign(__assign({ root: function (_a) {
            var theme = _a.theme;
            return ({
                textTransform: "initial",
                borderRadius: 0,
                padding: "0 ".concat(theme.spacing(2)),
                fontWeight: 400,
            });
        }, sizeSmall: function (_a) {
            var theme = _a.theme;
            return ({
                fontSize: 14,
                lineHeight: theme.spacing(4),
            });
        }, sizeMedium: function (_a) {
            var theme = _a.theme;
            return ({
                fontSize: 14,
                lineHeight: theme.spacing(5),
            });
        }, sizeLarge: function (_a) {
            var theme = _a.theme;
            return ({
                fontSize: 16,
                lineHeight: theme.spacing(6),
            });
        }, contained: {
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
            "&:focus": { boxShadow: "none" },
            "&:focus-visible": { boxShadow: "none" },
        } }, containedVariants()), outlinedVariants()), textVariants()),
};
